import React from "react";
import { AI_DISCLAIMER_BODY, PRIVACY_LABEL, PRIVACY_URL, TERMS_LABEL, TERMS_URL } from "../../config/aiDisclaimer";
import tdcLogo from "../../assets/logo-transparent-tdc-only.png";
import { BORDER, TEXT_DISCLAIMER, TEXT_FAINT } from "./theme";

// Footer disclaimer for the proposal pages: tiny TDC logo + company name +
// the shared AI/trademark copy. Mirrors the PDP audit page's disclaimer.
const FONT = "'DM Sans', sans-serif";

export function ProposalDisclaimer() {
    return (
        <div
            style={{
                fontFamily: FONT,
                display: "flex",
                gap: 10,
                alignItems: "flex-start",
                marginTop: 32,
                paddingTop: 16,
                borderTop: `1px solid ${BORDER}`,
            }}
        >
            <img
                src={tdcLogo}
                alt="The Desire Company"
                style={{ width: 22, height: 22, objectFit: "contain", flexShrink: 0, marginTop: 2 }}
            />
            <p style={{ fontSize: 11.5, color: TEXT_DISCLAIMER, lineHeight: 1.6, margin: 0 }}>
                <strong style={{ color: TEXT_FAINT }}>The Desire Company</strong> — {AI_DISCLAIMER_BODY}
                <a
                    href={TERMS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: TEXT_FAINT, textDecoration: "underline" }}
                >
                    {TERMS_LABEL}
                </a>
                {" and "}
                <a
                    href={PRIVACY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: TEXT_FAINT, textDecoration: "underline" }}
                >
                    {PRIVACY_LABEL}
                </a>
                .
            </p>
        </div>
    );
}
